import(/* webpackMode: "eager", webpackExports: ["ForgotPassword"] */ "/app/src/components/modules/(auth)/forgot-password/ForgotPassword.tsx");
